export const setInitialValues = (fecha, datos) => {
    return {
        fecha: fecha,
        entrantes: datos.data[fecha].stats[0].value, 
        alumnos: datos.data[fecha].stats[1].value,
        nuevos: datos.data[fecha].stats[2].value,
        ventas: datos.data[fecha].stats[3].value
    }
}